import Vue from 'vue';
import QRCode from 'qrcode';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'qrcodeCreated',
    props: {
        url: {
            type: String,
            default: '',
        },
        amount: {
            type: Number,
            default: 0,
        },
        purchaseCode: {
            type: String,
            default: '',
        },
    },
    data: function () {
        return {
            clearTimeout: true,
        };
    },
    mounted: function () {
        this.qrCreated();
    },
    beforeDestroy: function () {
        this.clearTimeout = false;
    },
    methods: {
        qrCreated: function () {
            var _a = this, url = _a.url, purchaseCode = _a.purchaseCode;
            var this_ = this;
            if (url === '') {
                return this.$message.error('获取URL失败');
            }
            var canvas = document.getElementById('canvas');
            QRCode.toCanvas(canvas, url, {
                style: 'width:280px;height:280px',
            }, function (error) {
                if (error) {
                    console.error(error);
                }
                this_.$store.dispatch('violationManage/GET_QR_STATUS', {
                    purchaseCode: purchaseCode,
                    callback: this_.getStatus,
                });
            });
        },
        getStatus: function (res) {
            var _this = this;
            if (!this.clearTimeout) {
                return;
            }
            var purchaseCode = this.purchaseCode;
            if (res.errorCode === 0) {
                var status = res.data.status;
                if (status !== 'SUCCESS' && status !== 'FAIL' && status !== 'WIENER') {
                    setTimeout(function () {
                        _this.$store.dispatch('violationManage/GET_QR_STATUS', {
                            purchaseCode: purchaseCode,
                            callback: _this.getStatus,
                        });
                    }, 2000);
                    return;
                }
                this.$store.commit('violationManage/update', {
                    qrStatus: res.data,
                });
            }
        },
        changeYuan: function (val) {
            return toYuan(val);
        },
    },
});
